// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".sTIQo0q9KzYu83j3rPof7A\\=\\={border-radius:.25rem !important}", "",{"version":3,"sources":["webpack://./components/Radio/styles.module.scss"],"names":[],"mappings":"AAEA,4BACE,+BAAA","sourcesContent":["@use '@/styles/global';\n\n.rounded {\n  border-radius: global.$field-radius !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"rounded": "sTIQo0q9KzYu83j3rPof7A=="
};
export default ___CSS_LOADER_EXPORT___;
